///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: 'button[windeClose]',
    standalone: false
})
export class CloseButtonDirective {
    @HostBinding('class') buttonClass = 'winde-button winde-close winde-action-icon';
    @HostBinding('type') buttonType = 'button';
}
